// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kizh","left":"styles_left__1_QjM","right":"styles_right__OvyAE","alert":"styles_alert__36xfu"};